import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { Loader2, Check, ArrowRight } from "lucide-react";

export default function PaymentSuccess() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const sessionId = params.get("session_id") || params.get("ref");
  const [status, setStatus] = useState("checking");
  const [tx, setTx] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!sessionId) { setErr("Missing session id"); setStatus("failed"); return; }
    let attempts = 0;
    const max = 7;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setTx(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        attempts++;
        if (attempts >= max) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        setErr(formatErr(e?.response?.data?.detail) || e.message);
        setStatus("failed");
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="min-h-screen flex items-center justify-center px-5 py-20">
      <div className="border border-[#1F3325] bg-[#0F1712] p-10 w-full max-w-lg text-center">
        {status === "checking" && (
          <>
            <Loader2 className="animate-spin mx-auto text-[#8DE038]" size={42}/>
            <h2 className="font-display uppercase text-2xl text-[#F0F4F1] mt-4">Confirming payment…</h2>
            <p className="text-[#9CAEA3] mt-2 text-sm">This can take a few seconds.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-[#8DE038] text-[#050806] flex items-center justify-center mx-auto mb-5"><Check size={32}/></div>
            <h2 className="font-display uppercase text-3xl tracking-tighter text-[#F0F4F1]">Booking confirmed!</h2>
            <p className="text-[#9CAEA3] mt-3">We've taken the platform fee of £{(tx?.amount_total || 0) / 100}. Your job has been broadcast to local Green Connect pros — you'll be notified once one accepts.</p>
            <Link to="/me/bookings" data-testid="go-to-bookings" className="btn-primary mt-7 inline-flex">My Bookings <ArrowRight size={16}/></Link>
          </>
        )}
        {(status === "expired" || status === "failed" || status === "timeout") && (
          <>
            <h2 className="font-display uppercase text-2xl text-red-400">Payment {status}</h2>
            <p className="text-[#9CAEA3] mt-2 text-sm">{err || "We couldn't confirm your payment. Please try again."}</p>
            <Link to="/book" className="btn-secondary mt-7 inline-flex">Try again</Link>
          </>
        )}
      </div>
    </div>
  );
}
